import React, { useEffect, useState } from 'react';
import './css/Register.css';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/AddCircle';
import ListCheckIcon from '@mui/icons-material/Grading';
import { CircularProgress, IconButton } from "@mui/material";
import TextField from "@mui/material/TextField";
import {AutoGraphTwoTone, EditTwoTone, PodcastsTwoTone, RemoveCircle, SmartToyTwoTone} from "@mui/icons-material";
import { Link, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ListedMachinePanel from './ListedMachinePanel';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import {padding} from "@mui/system";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";

function ListedMachines({ onAction, onSwitchToLicensed, onSwitchToEvents }) {
    return <MachinesSection onMachinesUpdated={onAction} onSwitchToLicensed={onSwitchToLicensed} onSwitchToEvents={onSwitchToEvents} />;
}

function MachinesSection({ onMachinesUpdated, onSwitchToLicensed, onSwitchToEvents }) {
    const [machines, setMachines] = useState([]);
    const [newMachineId, setNewMachineId] = useState('');
    const [authToken, setAuthToken] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [isAdding, setIsAdding] = useState(false);
    const [licenses, setLicenses] = useState([]);
    const [editModes, setEditModes] = useState({});

    const fetchMachines = () => {
        setLoading(true);
        const token = Cookies.get('auth');
        if (token) {
            setAuthToken(token);
            fetch(`../api/listing/getListings?token=${encodeURIComponent(token)}`)
                .then(response => response.json())
                .then(data => {
                    setMachines(data);
                    setLoading(false);
                    data.forEach(machine => {
                        setEditModes({
                            ...editModes,
                            [machine.machineId]: machine.duration <= 720 ? "days" : "date"});
                        console.log("editMode" + editModes[machine.machineId]);
                        console.log("pre duration" + machine.duration);
                        machine.duration = machine.duration <= 720 ? machine.duration : moment(machine.duration).format("YYYY-MM-DD");
                        console.log("post duration" + machine.duration);
                    });


                })
                .catch(error => {
                    console.error('Error fetching machines:', error);
                    setLoading(false);
                });
        } else {
            console.log('No token present in cookies.');
            setLoading(false);
        }
    };

    const fetchLicenses = () => {
        setLoading(true);
        const token = Cookies.get('auth');
        if (token) {
            setAuthToken(token);
            fetch(`../api/license/getLicenses?token=${encodeURIComponent(token)}`)
                .then(response => response.json())
                .then(data => {
                    setLicenses(data);
                    setLoading(false);
                })
                .catch(error => {
                    console.error('Error fetching licenses:', error);
                    setLoading(false);
                });
        } else {
            console.log('No token present in cookies.');
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMachines();
        fetchLicenses();
    }, []);

    const handleAddMachine = () => {
        setIsAdding(true);
        const isExisting = machines.some(machine => machine.machineId.toString() === newMachineId);
        if (isExisting) {
            setErrorMessage('Machine already added.');
            setIsAdding(false);
            return;
        }

        fetch(`../api/listing/createListing?token=${encodeURIComponent(authToken)}&m_id=${newMachineId}`, {
            method: 'GET',
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Machine does not exist');
                }
                return response.json();
            })
            .then(data => {
                setMachines(currentMachines => [...currentMachines, data]);
                setNewMachineId('');
                setErrorMessage('');
                onMachinesUpdated();
                setIsAdding(false);
            })
            .catch(error => {
                setErrorMessage(error.message);
                setIsAdding(false);
            });
    };

    const handleDeleteMachine = (machineId) => {
        const url = `../api/listing/delListing?token=${encodeURIComponent(authToken)}&m_id=${machineId}`;
        fetch(url, {
            method: 'GET',
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to delete machine');
                }
                setMachines(currentMachines => currentMachines.filter(machine => machine.machineId !== machineId));
                onMachinesUpdated();
            })
            .catch(error => {
                console.error('Error deleting machine:', error);
                alert('Error deleting machine');
            });
    };

    return (
        <div className="SectionEmbedded">
            <div className="SectionLtr">
        <span className="SectionBoxEmbedded">
          <span className="SectionSubHeadingEmbedded">LISTED MACHINES</span>
            <span className="SectionSubHeadingExtraEmbedded "> AGENT ADVISOR & CLIENT </span>
            {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                    <CircularProgress />
                </div>
            ) : (
                machines && machines.length > 0 && (
                    <div>
                        <div className="divLineDualGrad"></div>
                        <div className="table-container">
                            <Table className="listingsTable">
                                <TableHead>
                                    <TableHeader/>
                                </TableHead>

                                    <TableData
                                        machines={machines}
                                        editModes={editModes}
                                        setEditModes={setEditModes}
                                        onDelete={handleDeleteMachine}
                                        setMachines={setMachines}
                                        authToken={authToken}
                                        onMachinesUpdated={onMachinesUpdated}
                                        licenses={licenses}
                                    />

                            </Table>

                        </div>
                        <div className="divLineDualGrad"></div>
                    </div>
                )
            )}
            <div className="ButtonBarEmbedded">
            <span className="_button_holder">
              <TextField
                  error={Boolean(errorMessage)}
                  helperText={errorMessage}
                  id="new_machine_id"
                  focused
                  label="New Machine ID"
                  size="small"
                  value={newMachineId}
                  onChange={(e) => {
                      setNewMachineId(e.target.value);
                      setErrorMessage('');
                  }}
                  style={{ width: 200 }}
                  InputProps={{
                      style: {
                          fontSize: '1.2em',
                      },
                  }}
                  InputLabelProps={{
                      style: {
                          fontSize: '1.2em',
                      },
                  }}
              />
            </span>
            <span className="_button_holder">
              {isAdding ? (
                  <CircularProgress size={32} />
              ) : (
                  <Button variant="contained" size="medium" startIcon={<AddIcon />} onClick={handleAddMachine}>
                      Add
                  </Button>
              )}
            </span>
            <span className="_button_holder">
              <Button
                  variant="outlined"
                  size="medium"
                  startIcon={<SmartToyTwoTone />}
                  onClick={onSwitchToLicensed}
              >
                LICENSES
              </Button>
            </span>
            <span className="_button_holder">
              <Button
                  variant="outlined"
                  size="medium"
                  startIcon={<PodcastsTwoTone />}
                  onClick={onSwitchToEvents}
              >
                EVENTS
              </Button>
            </span>
          </div>
        </span>
            </div>
            <div className="SectionLtr">
                {machines.filter(machine => machine.enabled).map((machine) => (
                    <ListedMachinePanel key={machine.machineId} machineId={machine.machineId} />
                ))}
            </div>
        </div>
    );
}

function TableHeader() {
    return (
        <tr className="trHeader">

            <td>Enabled</td>
            <td>Machine</td>
            <td>Min GPU</td>
            <td>Min Price</td>
            <td>Inet Up</td>
            <td>Inet Down</td>
            <td>Storage</td>
            <td>Discount</td>
            <td>Price Level</td>
            <td style={{minWidth: '50px'}}>Duration</td>
            <td>Status</td>
            <td colSpan="2">Actions</td>
        </tr>
    );
}

function TableData({ machines, editModes, setEditModes, onDelete, setMachines, authToken, onMachinesUpdated, licenses = [] }) {
    const [originalMachines, setOriginalMachines] = useState({});
    const [datePickerOpen, setDatePickerOpen] = useState({});
    const [selectedDate, setSelectedDate] = useState({});

    const handleDateChange = (machineId, newDate) => {
        updateMachineDuration(machineId, newDate.toISOString().split('T')[0]);
        setSelectedDate((prev) => ({ ...prev, [machineId]: newDate }));
        toggleDatePicker(machineId, false);
    };

    const updateMachineDuration = (machineId, newDuration) => {
        setMachines(machines.map(machine => (
            machine.machineId === machineId ? { ...machine, duration: newDuration } : machine
        )));
        onMachinesUpdated();
    };

    const toggleDatePicker = (machineId, openState) => {
        setDatePickerOpen((prev) => ({ ...prev, [machineId]: openState }));
    };

    const handleSwitchChange = (machineId, isEnabled) => {
        const url = `../api/listing/enableListing?token=${encodeURIComponent(authToken)}&m_id=${machineId}&is_e=${isEnabled}`;
        fetch(url, {
            method: 'GET',
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to update machine status');
                }
                setMachines(currentMachines => currentMachines.map(machine => {
                    if (machine.machineId === machineId) {
                        return { ...machine, enabled: isEnabled };
                    }
                    return machine;
                }));
                onMachinesUpdated();
                console.log('Machine status updated successfully');
            })
            .catch(error => {
                console.error('Error updating machine status:', error);
            });
    };

    const toggleEdit = (machineId) => {
        setMachines(currentMachines => currentMachines.map(machine => {
            if (machine.machineId === machineId) {
                const isEditing = !machine.isEditable;
                if (isEditing) {
                    setOriginalMachines({
                        ...originalMachines,
                        [machineId]: { ...machine }
                    });
                } else {
                    const newOriginals = { ...originalMachines };
                    delete newOriginals[machineId];
                    setOriginalMachines(newOriginals);
                }
                return { ...machine, isEditable: isEditing };
            }
            return machine;
        }));
    };

    const toggleDurationMode = (machineId) => {
        setMachines(currentMachines => currentMachines.map(machine => {
            if (machine.machineId === machineId) {
                let newMode = editModes[machineId] === "date" ? "days" : "date";
                let newDuration = machine.duration;

                if (newMode === "date") {
                    let newDate = new Date();
                    newDate.setDate(newDate.getDate() + Number(machine.duration));
                    newDuration = newDate.toISOString().split("T")[0];
                } else {
                    let today = new Date();
                    let selectedDate = new Date(machine.duration);
                    newDuration = Math.ceil((selectedDate - today) / (1000 * 60 * 60 * 24)).toString();
                }

                setEditModes({
                    ...editModes,
                    [machineId]: newMode
                });

                return { ...machine, duration: newDuration };
            }
            return machine;
        }));
    };

    const handleCancelEdit = (machineId) => {
        setMachines(currentMachines => currentMachines.map(machine => {
            if (machine.machineId === machineId) {
                return { ...originalMachines[machineId], isEditable: false };
            }
            return machine;
        }));

        const newOriginals = { ...originalMachines };
        delete newOriginals[machineId];
        setOriginalMachines(newOriginals);
    };

    const handleInputChange = (event, machineId, field) => {
        const newValue = event.target.value;
        setMachines(currentMachines => currentMachines.map(machine => {
            if (machine.machineId === machineId) {
                return { ...machine, [field]: newValue };
            }
            return machine;
        }));
        onMachinesUpdated();
    };

    function handleSubmitChanges(machineId) {
        const machineIndex = machines.findIndex(m => m.machineId === machineId);
        if (machineIndex === -1) {
            console.error('Machine not found');
            return;
        }

        const originalMachines = [...machines];
        const updatedMachine = { ...machines[machineIndex], isEditable: false };

        setMachines(currentMachines => currentMachines.map((m, index) => index === machineIndex ? updatedMachine : m));

        const mode = editModes[machineId] === "date" ? "date" : "days";
        let offerDuration = updatedMachine.duration;
        console.log(mode, offerDuration);
        if (mode === "date") {
            const date = new Date(offerDuration);
            console.log(date, date.getTime());
            offerDuration = date.getTime();
        }

        const queryParams = new URLSearchParams({
            token: authToken,
            l_id: updatedMachine.id,
            is_enabled: updatedMachine.enabled,
            machine_id: updatedMachine.machineId,
            gpu_name: updatedMachine.gpuName,
            num_gpus: updatedMachine.numGpus,
            min_gpu: updatedMachine.minGpu,
            min_price: updatedMachine.minPrice,
            min_bid: updatedMachine.bidPrice,
            discount: updatedMachine.discountPerc,
            inet_up: updatedMachine.inetUp,
            inet_down: updatedMachine.inetDown,
            storage: updatedMachine.storage,
            price_level: updatedMachine.priceLevel,
            duration: offerDuration
        }).toString();

        const url = `../api/listing/updateListing?${queryParams}`;

        fetch(url, {
            method: 'GET',
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to update machine');
                }
                return response.json();
            })
            .then(data => {
                console.log('Machine updated successfully');
            })
            .catch(error => {
                console.error('Error updating machine:', error);
                setMachines(originalMachines);
            });
    }

    return (
        <tbody>
        {machines.map(machine => {
                // Find if any license for this machine has isVastEtlSub true
                const hasVastEtlSub = !machine.isEditable && licenses.some(
                    lic => lic.machineId === machine.machineId && lic.vastEtlSub
                );

                const hasListingSub = !machine.isEditable && licenses.some(
                    lic => lic.machineId === machine.machineId && lic.listingSub
                );

                const rowStyle = hasListingSub ? {
                    background: 'linear-gradient(to right, rgb(0, 0, 0, 0) 3%, rgb(0, 120, 0, 0.50) 10%, rgb(0, 0, 0, 0) 17%)'
                } : hasVastEtlSub
                    ? {
                        background: 'linear-gradient(to right, rgb(0, 0, 0, 0) 3%, rgb(80, 0, 120, 0.50) 10%, rgb(0, 0, 0, 0) 17%)'
                    }
                    : {backgroundColor: machine.isEditable ? '#305772' : 'transparent'};

                return (
                    <tr key={machine.machineId} style={rowStyle}>
                        <td>
                            <Switch
                                size="small"
                                checked={machine.enabled}
                                onChange={(e) => handleSwitchChange(machine.machineId, e.target.checked)}
                            />
                        </td>
                        <td>
                            <input value={machine.machineId} className="tableData" readOnly />
                            <div className="tdGpuInfo">{`${machine.gpuName} x ${machine.numGpus}`}</div>
                        </td>
                        <td>
                            <input
                                style={{color: machine.isEditable ? 'lightgreen' : 'lightblue'}}
                                readOnly={!machine.isEditable}
                                value={machine.minGpu}
                                onChange={(e) => handleInputChange(e, machine.machineId, 'minGpu')}
                                className="tableData"
                            />
                        </td>
                        <td>
                            <input
                                style={{color: machine.isEditable ? 'lightgreen' : 'lightblue'}}
                                readOnly={!machine.isEditable}
                                value={machine.minPrice}
                                onChange={(e) => handleInputChange(e, machine.machineId, 'minPrice')}
                                className="tableData"
                            />
                            <div className="tdGpuInfo">{`h $ ${(machine.minPrice * .75).toFixed(3)}`}</div>
                        </td>
                        <td>
                            <input
                                style={{color: machine.isEditable ? 'lightgreen' : 'lightblue'}}
                                readOnly={!machine.isEditable}
                                value={machine.inetUp}
                                onChange={(e) => handleInputChange(e, machine.machineId, 'inetUp')}
                                className="tableData"
                            />
                            <div className="tdGpuInfo">{`c $ ${(machine.inetUp * (100 / 75)).toFixed(3)}`}</div>
                        </td>
                        <td>
                            <input
                                style={{color: machine.isEditable ? 'lightgreen' : 'lightblue'}}
                                readOnly={!machine.isEditable}
                                value={machine.inetDown}
                                onChange={(e) => handleInputChange(e, machine.machineId, 'inetDown')}
                                className="tableData"
                            />
                            <div className="tdGpuInfo">{`c $ ${(machine.inetDown * (100 / 75)).toFixed(3)}`}</div>
                        </td>
                        <td>
                            <input
                                style={{color: machine.isEditable ? 'lightgreen' : 'lightblue'}}
                                readOnly={!machine.isEditable}
                                value={machine.storage}
                                onChange={(e) => handleInputChange(e, machine.machineId, 'storage')}
                                className="tableData"
                            />
                            <div className="tdGpuInfo">{`c $ ${(machine.storage * (100 / 75)).toFixed(2)}`}</div>
                        </td>
                        <td>
                            <input
                                style={{color: machine.isEditable ? 'lightgreen' : 'lightblue'}}
                                readOnly={!machine.isEditable}
                                value={machine.discountPerc}
                                onChange={(e) => handleInputChange(e, machine.machineId, 'discountPerc')}
                                className="tableData"
                            />
                        </td>
                        <td>
                            <select
                                value={machine.priceLevel}
                                onChange={(e) => handleInputChange(e, machine.machineId, 'priceLevel')}
                                disabled={!machine.isEditable}
                                style={{
                                    color: machine.isEditable ? 'lightgreen' : 'lightblue',
                                    background: machine.isEditable ? '#305772' : 'transparent',
                                    borderWidth: '0px',
                                    outline: 'none',
                                    border: 'none'
                                }}
                            >
                                <option value="0">Auto</option>
                                <option value="1">Level 1</option>
                                <option value="2">Level 2</option>
                                <option value="3">Level 3</option>
                                <option value="4">Level 4</option>
                                <option value="5">Level 5</option>
                            </select>
                        </td>
                        <td>
                            {editModes[machine.machineId] === "date" && machine.isEditable ? (
                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                    <input
                                        style={{
                                            color: machine.isEditable ? 'lightgreen' : 'lightblue',
                                            visibility: datePickerOpen[machine.machineId] ? 'hidden' : 'visible'
                                        }}
                                        readOnly={!machine.isEditable}
                                        value={machine.duration}
                                        className="tableData"
                                        onClick={() => toggleDatePicker(machine.machineId, true)}
                                    />
                                    {datePickerOpen[machine.machineId] && (
                                        <DatePicker
                                            open
                                            value={selectedDate[machine.machineId] || moment(machine.duration)}
                                            onChange={(newValue) => handleDateChange(machine.machineId, newValue)}
                                            onClose={() => toggleDatePicker(machine.machineId, false)}
                                            renderInput={(params) => <input {...params} style={{display: 'none'}}/>}
                                        />
                                    )}
                                </LocalizationProvider>
                            ) : (
                                <input
                                    style={{color: machine.isEditable ? 'lightgreen' : 'lightblue'}}
                                    readOnly={!machine.isEditable}
                                    value={machine.duration}
                                    onChange={(e) => handleInputChange(e, machine.machineId, 'duration')}
                                    className="tableData"
                                />
                            )}
                            {machine.isEditable ? (
                                <div className="tdGpuInfo" onClick={() => toggleDurationMode(machine.machineId)}>
                                    {editModes[machine.machineId] === "date" ? 'Switch to Days' : 'Switch to Date'}
                                </div>
                            ) : (
                                <div className="tdGpuInfo">
                                    {editModes[machine.machineId] === "date" ? 'date' : 'days'}
                                </div>
                            )}


                        </td>
                        <td className="tdStatus">

                            <div className="tdHalfHeight">ETL {hasVastEtlSub ? <CheckCircleIcon style={{ fontSize: '1.2em', lineHeight: '1.3em', verticalAlign: 'middle', textAlign: 'left', color: "lightgreen" }}/> :
                                <RemoveCircle style={{ fontSize: '1.2em', lineHeight: '1.3em', verticalAlign: 'middle', textAlign: 'left', color: "orange" }}/>}</div>
                            <div className="tdHalfHeight">GPU {hasListingSub ? <CheckCircleIcon style={{ fontSize: '1.2em', lineHeight: '1.3em', verticalAlign: 'middle', textAlign: 'left', color: "lightgreen" }}/> :
                                <RemoveCircle style={{ fontSize: '1.2em', lineHeight: '1.3em', verticalAlign: 'middle', textAlign: 'left', color: "orange" }}/>}</div>
                        </td>
                        {machine.isEditable ? (
                            <>
                                <td>
                                    <IconButton color="success" size="small"
                                                onClick={() => handleSubmitChanges(machine.machineId)}>
                                        <CheckCircleIcon/>
                                    </IconButton>
                                </td>
                                <td>
                                    <IconButton color="error" size="small"
                                                onClick={() => handleCancelEdit(machine.machineId)}>
                                        <CancelIcon/>
                                    </IconButton>
                                </td>
                            </>
                        ) : (
                            <>
                                <td>
                                    <IconButton color="primary" size="small" onClick={() => toggleEdit(machine.machineId)}>
                                        <EditIcon/>
                                    </IconButton>
                                </td>
                                <td>
                                    <IconButton color="primary" size="small" onClick={() => onDelete(machine.machineId)}>
                                        <DeleteIcon/>
                                    </IconButton>
                                </td>
                            </>
                        )}
                    </tr>
                );
            })}
        </tbody>
    );
}

function AddButton({ onClick }) {
    return (
        <Button variant="contained" size="medium" startIcon={<AddIcon />} onClick={onClick}>
            Add
        </Button>
    );
}

export default ListedMachines;
